import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { JQueryHTTPClient } from 'app/rest/JQueryHTTPClient';
import { EntityService } from 'app/rest/entity.service';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class FiltersService extends EntityService<Rest.FidFilters> {

	client: Rest.RestApplicationClient;
	startedEditing = new Subject<Rest.FidFilters>();
	endTranslationEditing = new Subject<Rest.FidFilters>();
	filterAdded = new Subject<Rest.FidFilters>();
	filterSaved = new Subject<Rest.FidFilters>();

	constructor(
		private jquery: JQueryHTTPClient,
		private http: HttpClient,
		private auth: AuthenticationService,
		private notificationsService: NotificationsService
	) {
		super();
		this.client = new Rest.RestApplicationClient(jquery);
	}

	public updateFilter(data): Promise<Rest.FidFilters> {
		// console.log("[FILTERS-SERVICE] *** updateFilter ****");
		// console.log(data);
		return this.http
		.post(environment.webApiBaseUrl + `api/fid/filters/save`, data)
		.toPromise()
		.then((response: any) => {
			 return response;
		})
		.catch((error) => {
			 this.notificationsService.add(Severity.error, 'Error', error.message);
			 return null;
		});
	}

	public createFilter(data): Promise<Rest.FidFilters> {
		// console.log("[FILTERS-SERVICE] *** createFilter ****");
		// console.log(data);
		return this.http
		.post(environment.webApiBaseUrl + `api/fid/filters/`, data)
		.toPromise()
		.then((response: any) => {
			 return response;
		})
		.catch((error) => {
			 this.notificationsService.add(Severity.error, 'Error', error.message);
			 return null;
		});
	}

	public deleteFilter(data): Promise<Rest.FidFilters> {
		// console.log("[TARGETS-SERVICE] *** deleteFilter ****");
		// console.log(data);
		return this.http
		.delete(environment.webApiBaseUrl + `api/fid/filters/` + data)
		.toPromise()
		.then((response: any) => {
			 return response;
		})
		.catch((error) => {
			 this.notificationsService.add(Severity.error, 'Error', error.message);
			 return null;
		});
	}

}
